// version v2.0.0

import React from "react";
import { Link } from "react-router-dom";
import { Home, Search } from "lucide-react";

function NotFound() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-gray-100 flex items-center justify-center px-6">
      <div className="max-w-xl w-full text-center">

        {/* 404 */}
        <div className="mb-6">
          <h1 className="text-8xl md:text-9xl font-extrabold text-gray-200 select-none">
            404
          </h1>
        </div>

        {/* Card */}
        <div className="bg-white rounded-3xl shadow-xl border border-gray-100 p-8 md:p-10">

          <div className="flex justify-center mb-6">
            <div className="h-16 w-16 rounded-full bg-blue-100 flex items-center justify-center">
              <Search size={30} className="text-blue-600" />
            </div>
          </div>

          <h2 className="text-3xl font-bold text-gray-900 mb-3">
            Page Not Found
          </h2>

          <p className="text-gray-500 mb-8 leading-relaxed">
            The page you're looking for doesn't exist, may have been moved,
            or the URL may be incorrect.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">

            <Link
              to="/"
              className="
                inline-flex
                items-center
                justify-center
                gap-2
                px-6
                py-3
                rounded-xl
                bg-blue-600
                text-white
                font-medium
                hover:bg-blue-700
                transition-all
                duration-300
                shadow-md
                hover:shadow-lg
              "
            >
              <Home size={18} />
              Back to Home
            </Link>

            <button
              onClick={() => window.history.back()}
              className="
                px-6
                py-3
                rounded-xl
                border
                border-gray-200
                text-gray-700
                font-medium
                hover:bg-gray-50
                transition-all
                duration-300
              "
            >
              Go Back
            </button>

          </div>
        </div>

        <p className="mt-6 text-sm text-gray-400">
          Error Code: 404 • Resource Not Found
        </p>

      </div>
    </div>
  );
}

export default NotFound;